import { Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { TextLgRg } from '@/UI/AppTypography/AppTypography';

export function FigmaPromoHeader() {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" sx={{ gap: 4, textAlign: 'center', maxWidth: 560 }}>
      <Typography variant="h1" color={color.White100}>
        {t(I18N_KEYS.FIGMA_PROMO_WELCOME.TITLE)}
      </Typography>

      <Stack sx={{ gap: 2 }}>
        <TextLgRg color={color.White100}>{t(I18N_KEYS.FIGMA_PROMO_WELCOME.BODY)}</TextLgRg>

        <TextLgRg color={color.White100}>
          {t(I18N_KEYS.FIGMA_PROMO_WELCOME.CREDITS_PREFIX)}
          <Typography component="span" variant="body-lg-sb">
            {t(I18N_KEYS.FIGMA_PROMO_WELCOME.CREDITS_BOLD)}
          </Typography>
          {t(I18N_KEYS.FIGMA_PROMO_WELCOME.CREDITS_SUFFIX)}
        </TextLgRg>
      </Stack>
    </Stack>
  );
}
